<template>
  <tr>
    <td
      class="boss-table-data"
      data-test="job-id"
    >
      {{ job.id }}
    </td>
    <td
      class="boss-table-data"
      data-test="job-management-name"
    >
      {{ job.managementName }}
    </td>
    <td
      class="boss-table-data left"
      data-test="job-name"
    >
      {{ job.name }}
    </td>
    <td
      class="boss-table-data"
      data-test="job-first-last-date"
    >
      {{ job.firstDate }}〜{{ job.lastDate }}
    </td>
    <td
      class="boss-table-data"
      data-test="job-publish-size"
    >
      {{ job.publishSize }}
    </td>
    <td class="boss-table-data">
      <button
        class="boss-button pega-preview-button margin-03"
        data-test="job-button"
        @click="windowOpenPreview('previewJobConfirm')"
      >
        求人
      </button>
      <button
        class="boss-button pega-preview-button margin-03"
        data-test="job-search-preview-button"
        @click="openOfferSearchPreview"
      >
        検索一覧
      </button>
      <button
        v-if="job.companyMessageUrl"
        class="boss-button pega-preview-button margin-03"
        data-test="job-company-message-button"
        @click="openCompanyMessagePreview"
      >
        企業メッセージ
      </button>
    </td>
    <td
      v-if="isPublishing"
      class="boss-table-data"
    >
      <div class="switch toggle-switch">
        <input
          :id="`casual-interview-request-${ job.id }`"
          v-model="job.canCasualInterviewRequest"
          class="toggle-input"
          data-test="casual-interview-request-toggle-button"
          type="checkbox"
          @change="updateCanCasualInterviewRequest(job.id, $event)"
        >
        <label
          :for="`casual-interview-request-${ job.id }`"
          class="toggle-label"
        />
      </div>
    </td>
    <td
      v-if="isPublishing"
      class="boss-table-data"
    >
      <span
        v-if="job.isOriginalEntryForm"
        data-test="job-original-entry-type"
      >専用応募フォーム
      </span>
      <select
        v-else
        v-model="job.entryFormId"
        data-test="job-entry-form-select"
        class="boss-input-select"
        @change="updatePublishJob(job.id, job.entryFormId)"
      >
        <option
          v-for="(entryFormType , index) in entryFormTypes"
          :key="`type-${ index }`"
          :value="entryFormType.id"
          :data-test="`entry-form-type-${ index }`"
        >
          {{ entryFormType.name }}
        </option>
      </select>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    job: {
      type: Object,
      required: true
    },
    isPublishing: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      entryFormTypes: 'entryFormTypeMaster'
    })
  },
  methods: {
    updatePublishJob (jobId, entryFormTypeId) {
      this.$http.secured.put(`/preview/confirm/jobs/${jobId}/_entry_form_type`, { type: entryFormTypeId }
      ).then(() => {
        this.$toasted.global.success({ message: '応募フォームを更新しました。' })
      })
    },
    updateCanCasualInterviewRequest (jobId, event) {
      const afterCheckboxVal = event.target.checked
      this.$http.secured.put(`/preview/confirm/jobs/${jobId}/casual_interview_request_settings`, { canCasualInterviewRequest: afterCheckboxVal }
      ).then(() => {
        afterCheckboxVal
          ? this.$toasted.global.success({ message: '話を聞きたい応募受付をONにしました。' })
          : this.$toasted.global.success({ message: '話を聞きたい応募受付をOFFにしました。' })
      }).catch(() => {
        event.target.checked = !afterCheckboxVal
      })
    },
    windowOpenPreview (name) {
      const routeData = this.$router.resolve(
        this.job.folderChildId
          ? { name: name, params: { jobId: this.job.id }, query: { folderChildId: this.job.folderChildId } }
          : { name: name, params: { jobId: this.job.id } }
      )
      window.open(routeData.href, '_blank')
    },
    // USER側の検索一覧プレビューにアクセス
    openOfferSearchPreview () {
      this.$http.secured.get('/preview/preview_code').then(response => {
        window.open(this.job.searchPreviewUrl + '&previewCode=' + response.data, '_blank')
      })
    },
    // USER側の企業メッセージプレビューにアクセス
    openCompanyMessagePreview () {
      this.$http.secured.get('/preview/preview_code').then(response => {
        window.open(this.job.companyMessageUrl + '&previewCode=' + response.data, '_blank')
      })
    }
  }
}
</script>
